export default class SubmissionDeliveryChannel extends HTMLElement {
  connectedCallback () {
    this.addEventListener('change', () => this.sync())
    this.closest('form')?.querySelector('[data-global-sms-consent]')?.addEventListener('change', () => this.sync())
    this.sync()
  }

  sync () {
    const sms = this.querySelector('input[type="radio"][value="1"]')
    const selected = sms?.checked === true
    const fields = this.querySelector('[data-sms-fields]')
    fields?.classList.toggle('hidden', !selected)
    fields?.querySelectorAll('input, select').forEach((input) => { input.required = selected })

    const form = this.closest('form')
    const anySms = [...form.querySelectorAll('submission-delivery-channel input[type="radio"][value="1"]')]
      .some((input) => input.checked)
    const consent = form.querySelector('[data-sms-consent]')
    consent?.classList.toggle('hidden', !anySms)
    const checkbox = consent?.querySelector('input')
    if (checkbox) checkbox.required = anySms
    form.querySelectorAll('submission-delivery-channel').forEach((channel) => {
      const channelSms = channel.querySelector('input[type="radio"][value="1"]')?.checked === true
      channel.querySelector('[data-signer-consent]').value = channelSms && checkbox?.checked ? '1' : '0'
    })
  }
}
